import i18next from 'i18next';
import Api from '../../services/Api';
import Helpers from '../../js/helpers';

export default {
  namespaced: true,
  state: {
    campaign: '',
    parameters: [
      'TEMPERATURE_MIN',
      'WIND_SPEED_MAX',
      'TEMPERATURE_MAX',
      'PLUVIOMETER',
      'HUMIDITY',
      'HUMIDITY_MAX',
      'HUMIDITY_MIN',
      'TEMPERATURE',
      'WIND_SPEED',
      'WIND_SPEED_MIN',
      'SOLAR_RADIATION',
      'SOLAR_RADIATION_MAX',
      'SOLAR_RADIATION_MIN',
    ],
    namePlantation: '',
    allCampaigns: [],
    allPlantations: [],
    parameterSelected: '',
    endDate: '',
    initDate: '',
    dataWeather: [],
    category: ['MEASURED', 'FORECAST'],
    dataDate: [],
    plantationSelected: '',
    allClients: [],
    clientSelected: '',
    searchInitDate: null,
    searchEndDate: null,
  },
  mutations: {
    UPDATE_PARAMETERS(state, value) {
      state.parameters = value;
    },
    setNamePlantation(state, value) {
      state.namePlantation = value;
    },
    UPDATE_ALL_CAMPAIGNS(state, value) {
      state.allCampaigns = value;
    },
    FETCH_PLANTATION_AVAILABLES(state, value) {
      state.allPlantations = value;
    },
    UPDATE_PARAMETER_SELECTED(state, value) {
      state.parameterSelected = value;
    },
    UPDATE_INIT_DATE(state, value) {
      state.initDate = value;
    },
    UPDATE_END_DATE(state, value) {
      state.endDate = value;
    },
    UPDATE_DATA_WEATHER(state, value) {
      let isSame = false;
      state.dataWeather.forEach((param) => {
        if (Array.isArray(param)) {
          if (param[0].name === value[0].name) {
            isSame = true;
          }
        }
      });

      if (isSame) return;
      state.dataWeather.push(value);
    },
    UPDATE_DATA_DATE(state, value) {
      if (state.dataDate.length !== 0) {
        state.dataDate = state.dataDate.concat(value);
      } else {
        state.dataDate = value;
      }
    },
    UPDATE_DATADATE_RESET(state, value) {
      state.dataDate = value;
    },
    UPDATE_DATAWEATHER_RESET(state, value) {
      state.dataWeather = value;
    },
    setPlantationId(state, value) {
      state.plantationSelected = value;
    },
    setClient(state, value) {
      state.clientSelected = value;
    },
    fetchDataClients(state, value) {
      state.allClients = value;
    },
    setWeatherSearchInitDate(state, value) {
      state.searchInitDate = value;
    },
    setWeatherSearchEndDate(state, value) {
      state.searchEndDate = value;
    },
  },
  actions: {
    async getWidgetData({ rootState }, data) {
      try {
        // Añadimos el sectorId al objeto data
        data.sectorId = rootState.Plantation.currentPlantation.sectorId;
        const xhr = await Api.getWeatherWidgetData(
          data,
          rootState.Plantation.currentPlantation.companyId,
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getAllCampaigns({ commit }) {
      try {
        const xhr = await Api.getAllCampaignsForUser();
        const campaign = JSON.parse(xhr.response).data;
        const allCamp = [];
        for (let i = 0; i < campaign.length; i += 1) {
          allCamp.push({
            name: campaign[i].name,
            id: campaign[i].id,
            company: campaign[i].company,
          });
        }
        commit(
          'UPDATE_ALL_CAMPAIGNS',
          allCamp,
        );
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async getWeatherParameter({ commit, state }) {
      try {
        const idCompany = state.clientSelected;
        const xhr = await Api.getWeatherByPlantation(idCompany, state.plantationSelected, state.category[0], state.initDate, state.endDate, state.parameterSelected);
        const weatherParameter = JSON.parse(xhr.response);
        const dataParameters = [];
        const dataDate = [];
        for (const parameter in weatherParameter[0].parameters) {
          if (Object.hasOwnProperty.call(weatherParameter[0].parameters, parameter)) {
            if (parameter === state.parameterSelected) {
              for (const dataParameter of weatherParameter[0].parameters[parameter]) {
                dataDate.push({
                  date: dataParameter.date,
                  [`${i18next.t(`WeatherParameter.${state.parameterSelected.split('-')[0]}`)}-${state.namePlantation}`]: dataParameter.value,
                });
              }
              commit(
                'UPDATE_DATA_DATE',
                dataDate,
              );
            }
          }
        }
        dataParameters.push({
          name: `${i18next.t(`WeatherParameter.${state.parameterSelected.split('-')[0]}`)}-${state.namePlantation}`,
          value: `${i18next.t(`WeatherParameter.${state.parameterSelected.split('-')[0]}`)}-${state.namePlantation}`,
        });
        commit(
          'UPDATE_DATA_WEATHER',
          dataParameters,
        );
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async getAllClients({ commit }) {
      try {
        const xhr = await Api.getCompanies('');
        const response = JSON.parse(xhr.response);
        const dataClients = response.results.map((company) => ({
          id: company.id,
          name: company.name,
        }));
        commit(
          'fetchDataClients',
          dataClients,
        );
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async getClimateData({ rootState }, data) {
      try {
        const xhr = await Api.getClimateData(
          data,
          rootState.Plantation.currentPlantation.companyId,
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getPlantationByCompany({ commit, state, rootGetters }, actualUserId = '') {
      try {
        const CompanyId = state.clientSelected;
        const xhr = await Api.getPlantationByCompanyId(CompanyId);
        const plantationAvailables = JSON.parse(xhr.response).data;
        const dataPlantationFormatted = [];
        for (let i = 0; i < plantationAvailables.length; i += 1) {
          dataPlantationFormatted.push({
            id: plantationAvailables[i].id,
            name: plantationAvailables[i].name,
          });
        }
        commit(
          'FETCH_PLANTATION_AVAILABLES',
          dataPlantationFormatted,
        );
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    setNamePlantation(context, value) {
      context.commit('setNamePlantation', value);
    },
    setParameterSelected(context, value) {
      context.commit('UPDATE_PARAMETER_SELECTED', value);
    },
    setInitDate(context, value) {
      context.commit('UPDATE_INIT_DATE', value);
    },
    setEndDate(context, value) {
      context.commit('UPDATE_END_DATE', value);
    },
    setPlantationId(context, value) {
      context.commit('setPlantationId', value);
    },
    setClient(context, value) {
      context.commit('setClient', value);
    },
    initStoreGraph({ commit }) {
      commit('UPDATE_DATAWEATHER_RESET', []);
      commit('UPDATE_DATADATE_RESET', []);
    },
    setWeatherSearchInitDate({ commit }, value) {
      commit('setWeatherSearchInitDate', value);
    },
    setWeatherSearchEndDate({ commit }, value) {
      commit('setWeatherSearchEndDate', value);
    },
    initStoreRegister({ commit }) {
      commit('UPDATE_DATAWEATHER_RESET', []);
      commit('UPDATE_ALL_CAMPAIGNS', []);
      commit('fetchDataClients', []);
      commit('UPDATE_PARAMETER_SELECTED', '');
      commit('UPDATE_INIT_DATE', '');
      commit('UPDATE_END_DATE', '');
      commit('setPlantationId', '');
      commit('FETCH_PLANTATION_AVAILABLES', []);
    },
  },
};
